import React from 'react';
import { useNavigate } from 'react-router-dom';
import BrutalHeader from './BrutalHeader';
import './App.css';
import './LawFirms.css';
import './Other.css';

const ALL_INDUSTRIES = [
  { label: 'Law',   href: '/industries/law-firms' },
  { label: 'Publishing',  href: '/industries/publishing' },
  { label: 'Healthcare',  href: '/industries/healthcare' },
  { label: 'Real Estate', href: '/industries/real-estate' },
  { label: 'Service',     href: '/industries/services' },
  { label: 'Restaurants', href: '/industries/restaurants' },
  { label: 'Other',       href: '/industries/other' },
];

export default function Other() {
  const navigate = useNavigate();

  return (
    <div className="industry-shell">
      <BrutalHeader />

      <section className="other-hero">
        <div className="other-hero-img-wrap">
          <img src="/other-hero.jpg" alt="Diverse business professionals" className="other-hero-img" />
          <div className="other-hero-overlay" />
        </div>
        <div className="other-hero-content">
          <div className="industry-tabs other-tabs">
            {ALL_INDUSTRIES.map((ind) => (
              <a
                key={ind.label}
                href={ind.href}
                className={`industry-tab${ind.href === '/industries/other' ? ' industry-tab-active' : ''}`}
                onClick={ind.href === '/industries/other' ? (e) => e.preventDefault() : undefined}
              >
                {ind.label}
              </a>
            ))}
          </div>
          <span className="industry-eyebrow">Other Industries</span>
          <h1 className="other-hero-title">The best data comes from<br /><span className="other-hero-highlight">unexpected places.</span></h1>
          <p className="other-hero-subtitle">
            Some of the most valuable datasets in the market come from industries no one thinks to ask.
            Niche businesses capture highly specific, hard-to-replicate data — and that scarcity is exactly what makes it worth something.
          </p>
          <p className="other-hero-subtitle">
            If you're not sure whether your industry qualifies, reach out. We'd love to hear about your business.
          </p>
          <button className="industry-cta-btn other-cta-btn" onClick={() => navigate('/signup')}>
            Get in touch →
          </button>
        </div>
      </section>
    </div>
  );
}
